import { Component, OnInit } from '@angular/core';

import {
    AbstractControl,
    FormControl,
    FormGroup,
    Validators,
} from '@angular/forms';
import { Router } from '@angular/router';

import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { TokenService } from 'src/app/core/services/token.service';

import { UserService } from 'src/app/core/services/user.service';
import {
    ZtButtonConfig,
    ZtButtonType,
} from 'src/app/shared/components/atoms/zt-button/zt-button.model';
import { ZtIcon } from 'src/app/shared/components/atoms/zt-icon/zt-icon.model';
import { ZtTextInputConfig } from 'src/app/shared/components/atoms/zt-textinput/zt-textinput.model';
import { ZtLoaderService } from 'src/app/shared/components/molecules/zt-loader/zt-loader.service';

@UntilDestroy()
@Component({
    selector: 'zt-signup',
    templateUrl: 'signup.component.html',
    styleUrls: ['signup.component.scss'],
})
export class SignupComponent implements OnInit {
    usernameFieldConfig: ZtTextInputConfig = {
        id: 'username',
        name: 'username',
        label: 'Username',
    };

    emailFieldConfig: ZtTextInputConfig = {
        id: 'email',
        name: 'email',
        label: 'Email',
    };

    passwordFieldConfig: ZtTextInputConfig = {
        id: 'password',
        name: 'password',
        label: 'Password',
        type: 'password',
    };

    signupBtnConfig: ZtButtonConfig = {
        id: 'login',
        name: 'login',
        icon: ZtIcon.ARROW_RIGHT,
    };

    signupForm = new FormGroup({
        username: new FormControl<string>('', Validators.required),
        email: new FormControl<string>('', Validators.email),
        password: new FormControl<string>('', [
            Validators.required,
            Validators.minLength(5),
        ]),
    });

    constructor(
        private userService: UserService,
        private loadingService: ZtLoaderService,
        private tokenService: TokenService,
        private router: Router
    ) {}

    ngOnInit() {}

    onSubmitHandler(event: Event): void {
        event.preventDefault();
    }

    signupClickHandler(): void {
        if (this.signupForm.touched && this.signupForm.valid) {
            this.loadingService.showLoader();
            this.userService
                .register(
                    this.signupForm.value.email!,
                    this.signupForm.value.username!,
                    this.signupForm.value.password!
                )
                .pipe(untilDestroyed(this))
                .subscribe({
                    next: (data: any) => {
                        this.userService
                            .login(
                                this.signupForm.value.email!,
                                this.signupForm.value.password!
                            )
                            .pipe(untilDestroyed(this))
                            .subscribe({
                                next: (token: any) => {
                                    this.tokenService.setToken(token.token);
                                    this.router.navigate(['/']);
                                    this.loadingService.hideLoader();
                                },
                                error: (error: Error) => {
                                    this.loadingService.hideLoader();
                                },
                            });
                    },
                    error: (error: Error) => {
                        this.loadingService.hideLoader();
                    },
                });
        }
    }

    get ZtButtonType(): typeof ZtButtonType {
        return ZtButtonType;
    }

    get usernameControl(): AbstractControl<
        string | null,
        string | null
    > | null {
        return this.signupForm.get('username');
    }

    get emailControl(): AbstractControl<string | null, string | null> | null {
        return this.signupForm.get('email');
    }

    get passwordControl(): AbstractControl<
        string | null,
        string | null
    > | null {
        return this.signupForm.get('password');
    }
}
